import { Doughnut } from "react-chartjs-2";
import { useEffect, useRef, useState } from "react";

const PercentageChart = ({ listMonthsTwo, max }) => {
  const [listData, setListData] = useState([]);

  const data = {
    labels: ["Contagem OK", "Sobras", "Faltas"], // Rótulos para as barras
    datasets: [
      {
        data: listData,
        backgroundColor: ["#123164", "#476EE6", "#EA0000"], // Cores das barras
      },
    ],
  };

  const options = {
    scales: {},
    plugins: {
      legend: {
        display: false, // Remove a exibição da legenda
      },
      title: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    elements: {
      bar: {
        borderWidth: 1,
        borderRadius: 4,
      },
    },
    layout: {
      padding: {
        top: 20,
        bottom: 20,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
  };

  useEffect(() => {
    setListData(listMonthsTwo);
  }, [listMonthsTwo]);

  return (
    <div
      style={{
        width: "49%",
        height: "329px",
      }}
    >
      {/* <Doughnut data={data} options={options} /> */}
    </div>
  );
};

export default PercentageChart;
